import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Layout } from './components/Layout';
import { HomePage } from './pages/HomePage';
import { CoursesPage } from './pages/CoursesPage';
import { CourseDetailPage } from './pages/CourseDetailPage';
import { HaccpLevel12Page } from './pages/HaccpLevel12Page';
import { ContactPage } from './pages/ContactPage';
import { HelpCentrePage } from './pages/HelpCentrePage';
import { CorporatePage } from './pages/CorporatePage';
import { ResourcesPage } from './pages/ResourcesPage';
import { BlogPage } from './pages/BlogPage';
import { BlogPostPage } from './pages/BlogPostPage';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <Router data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Layout data-id="element-2">
        <Routes data-id="element-3">
          <Route path="/" element={<HomePage data-id="element-5" />} data-id="element-4" />
          <Route path="/courses" element={<CoursesPage data-id="element-7" />} data-id="element-6" />
          <Route path="/courses/haccp-level-1-2" element={<HaccpLevel12Page data-id="element-9" />} data-id="element-8" />
          <Route path="/contact" element={<ContactPage data-id="element-11" />} data-id="element-10" />
          <Route path="/help" element={<HelpCentrePage data-id="element-13" />} data-id="element-12" />
          <Route path="/corporate" element={<CorporatePage data-id="element-15" />} data-id="element-14" />
          <Route path="/resources" element={<ResourcesPage data-id="element-17" />} data-id="element-16" />
          <Route path="/blog" element={<BlogPage data-id="element-19" />} data-id="element-18" />
          <Route path="/blog/:id" element={<BlogPostPage data-id="element-21" />} data-id="element-20" />
          <Route path="/courses/:id" element={<CourseDetailPage data-id="element-23" />} data-id="element-22" />
        </Routes>
      </Layout>
    </Router>;
}